up.compiler('.billing-toggle', (element: HTMLElement) => {
    const cleanup = [];

    const clickHandler = (ev: Event, el: HTMLElement) => {
        var links = element.querySelectorAll('a');

        links.forEach(link => {
            link.classList.remove('billing-toggle-item--selected');
        });
    };

    element.classList.add('billing-toggle--animates');

    cleanup.push(up.on(element, 'click', 'a', clickHandler));

    return () => {
        cleanup.forEach(fn => fn());
    }
});